// filepath: /Users/luisaabello/Documents/lummo-ai/lummo-frontend-web/src/components/problem/problemData.ts
export interface ProblemCardData {
  id: string;
  title: string;
  description: string;
  image: string;
  badges?: string[];
}

export const problems: ProblemCardData[] = [
  {
    id: 'setup-paralysis',
    title: 'Setup Paralysis',
    description: 'Study startup drags to 18+ months due to manual protocol parsing and endless paperwork.',
    image: '/images/setup_paralysis.png',
    badges: ['Time', 'Bureaucracy']
  },
  {
    id: 'regulatory-fragmentation',
    title: 'Regulatory Fragmentation',
    description: '12 regulatory frameworks across LATAM with little coordination—each submission is a gamble.',
    image: '/images/fragmentation.png',
    badges: ['Compliance', 'LATAM']
  },
  {
    id: 'patient-desert',
    title: 'Patient Desert',
    description: '85% of trials miss enrollment targets; legacy tools fail to reach patients effectively.',
    image: '/images/patient.png',
    badges: ['Enrollment', 'Reach']
  },
  {
    id: 'data-chaos',
    title: 'Data Chaos',
    description: 'Disconnected systems erode data integrity and introduce operational friction.',
    image: '/images/chaos.png',
    badges: ['Data', 'Integrity']
  }
];
